import { render, staticRenderFns } from "./GrupoEconomico.vue?vue&type=template&id=5efc51fc"
import script from "./GrupoEconomico.vue?vue&type=script&lang=js"
export * from "./GrupoEconomico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports